import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, timeout } from "rxjs";
import { environment } from '../../environments/environment';
import { BBResponseContainer } from "../carrier/response-container";
import { formatDate } from "@angular/common";
import { RunCommentDTO } from "../models-new/sampleCommentDTO";
import { Run } from "../models-new/run";

@Injectable({
	providedIn: 'root'
})
export class MachineNewService {

	MACHINE_API = environment.BB_MA_DELIVERY_API + "run";

	constructor(readonly httpClient: HttpClient) { }

	updateRun(run: Run, labId: string): Observable<BBResponseContainer> {
		const url = `${this.MACHINE_API}/updateRun/${labId}/${run.runId}`;
		return this.httpClient.put<BBResponseContainer>(url, run).pipe(timeout(environment.defaultTimeout));
	}

	createRun(run: Run, labId: string): Observable<BBResponseContainer> {
		run.labId = labId;
		const url = `${this.MACHINE_API}/createRun`;
		return this.httpClient.post<BBResponseContainer>(url, run).pipe(timeout(environment.defaultTimeout));
	}

	fetchRuns(labId: string, status?: string, fromDate?: Date, toDate?: Date, selectedProjects?: string): Observable<BBResponseContainer> {
		let url = `${this.MACHINE_API}/getAllRuns/${labId}`;
		const params: any = {};

		if (status) {
			params.status = status;
		}

		if (fromDate) {
			const formattedFromDate = formatDate(fromDate, 'EEE MMM dd yyyy', 'en-US');
			params.fromDate = formattedFromDate;
		}

		if (toDate) {
			const formattedToDate = formatDate(toDate, 'EEE MMM dd yyyy', 'en-US');
			params.toDate = formattedToDate;
		}


		if (selectedProjects && selectedProjects.trim() !== "") {
			params.selectedProjects = selectedProjects;
		}

		const queryParams = new URLSearchParams(params).toString();
		if (queryParams) {
			url = `${url}?${queryParams}`;
		}

		return this.httpClient.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
	}


	fetchRun(runID: string, labId: string): Observable<BBResponseContainer> {
		const url = `${this.MACHINE_API}/getRun/${labId}/${runID}`;
		return this.httpClient.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
	}

	updateRunNewPlateID(requestBody: any) {
		const url = this.MACHINE_API + "/updateRun/duplicatePlate";
		return this.httpClient.put<BBResponseContainer>(url, requestBody).pipe(timeout(environment.defaultTimeout));
	}

	updateRunComment(labId: string, runId: string, comment: RunCommentDTO): Observable<BBResponseContainer> {
		const url = `${this.MACHINE_API}/addRunComment/${labId}/${runId}`;
		return this.httpClient.put<BBResponseContainer>(url, comment).pipe(timeout(environment.defaultTimeout));
	}

	getRunComments(labId: string, runId: string): Observable<BBResponseContainer> {
		const url = `${this.MACHINE_API}/runComments/${labId}/${runId}`;
		return this.httpClient.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
	}

}